module.exports = __webpack_public_path__ + "static/media/doorhandle.c7f7c931.png";